module.exports = __webpack_public_path__ + "img/error.b193f4a6.svg";